import React from "react";
import { createRoot } from "react-dom/client";

//  eslint-disable-next-line
//  import regeneratorRuntime from 'regenerator-runtime'

import * as Sentry from "@sentry/react";

import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

import {
  STORE_KEY_ACCOUNT,
  STORE_KEY_LIST,
  STORE_KEY_USER,
  storeGet,
} from "mailup-react-helpers";

import "mailup-web-components/bundle/css/legacy.css";
//  please keep this order
import "mailup-web-components/bundle/esm/css/assets.css";

import "./sass/style.scss";

import App from "./App";

const SENTRY_DSN = process.env.SENTRY_DSN;
const RELEASE = process.env.RELEASE;
const ENV = process.env.APP_ENV;
const IS_DEV = process.env.IS_DEV;

if (SENTRY_DSN && RELEASE) {
  // && !IS_DEV
  const account = storeGet(STORE_KEY_ACCOUNT);
  const list = storeGet(STORE_KEY_LIST);
  const user = storeGet(STORE_KEY_USER);

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: ENV,
    release: RELEASE,
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.reactRouterV6Instrumentation(
          React.useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        ),
      }),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: ENV === "DEV" || ENV === "QA" ? 1.0 : 0.01,

    initialScope: (scope) => {
      scope.setExtras({
        IdConsole: account
          ? Number.parseInt(storeGet(STORE_KEY_ACCOUNT).Id, 10)
          : 0,
        IdList: list ? Number.parseInt(list.IdList, 10) : 0,
        IdUser: user ? Number.parseInt(user.Id, 10) : 0,
      });
      return scope;
    },
  });
}

const container = document.getElementById("app");
const root = createRoot(container);

root.render(<App />);
